import React, { MouseEventHandler, ReactNode, useState } from "react";
import styled, { css } from "styled-components";
import cn from "classnames";
import SVG from "src/utils/SVG";
import IconButton from "./IconButton";

interface IChipProps {
  variant?: string;
  deleted?: boolean;
  selected?: boolean;
  disabled?: boolean;
  size?: string;
  level?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onDelete?: MouseEventHandler<HTMLButtonElement>;
}

const Chip = (props: IChipProps) => {
  // const [isCheck, setIsCheck] = useState(props.selected || false);
  // const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
  //   setIsCheck(!isCheck);
  // };

  return (
    <ChipSet
      variant={props.variant}
      size={props.size}
      level={props.level}
      className={cn({ selected: props.selected && !props.deleted }, { deleted: props.deleted }, { disabled: props.disabled })}
      onClick={props.onClick}
    >
      <span>{props.children}</span>
      {props.deleted && (
        <IconButton btnName="삭제하기" onClick={props.onDelete}>
          <SVG name="chipDel" width={10} height={10} viewBox="0 0 10 10" />
        </IconButton>
      )}
    </ChipSet>
  );
};

// Chip
// variant : contained(default) | outlined
// selected : false(default) -> with outlined
// deleted : false(default) -> with contained
// size : medium(default) | small
// lavel : level1 ~ level5
const variantStyle = css<IChipProps>`
  ${(props) => {
    switch (props.variant) {
      case "outlined":
        return css`
          border: 1px solid ${({ theme }) => theme.color.lineSecondary};
          background-color: #fff;
          color: ${({ theme }) => theme.color.secondary};
          &.selected {
            border: 1px solid ${({ theme }) => theme.color.main};
            background-color: rgba(78, 180, 217, 0.2);
            color: ${({ theme }) => theme.color.main};
          }
          &.disabled {
            border: 1px solid ${({ theme }) => theme.color.lineSecondary};
            background-color: ${({ theme }) => theme.color.bgPrimary};
          }
        `;
      // default
      default:
        return css`
          background-color: ${({ theme }) => theme.color.main};
          color: #fff;
        `;
    }
  }}
`;

const sizeStyle = css<IChipProps>`
  ${(props) => {
    switch (props.size) {
      case "small":
        return css`
          width: 60px;
          height: 24px;
          border-radius: calc(24px / 2);
          }
        `;
      // default
      default:
        return css`
          height: 28px;
          padding: 0 15px;
          border-radius: calc(28px / 2);
        `;
    }
  }}
`;

const ChipSet = styled.div.attrs({
  role: "button",
})<IChipProps>`
  ${({ theme }) => theme.flexBox.inlineFlex("center", "center")}
  font-size: 14px;
  ${variantStyle}
  ${sizeStyle}
  > span {
    display: inline;
    user-select: none;

    & + button {
      display: inline-flex;
      margin-left: 8px;
      vertical-align: baseline;
    }
  }
`;

export default Chip;
